/* Your Pet Memory — premium polish: sticky header, one-line nav guard, depth/parallax (no dependencies) */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  function mq(q) { return !!(w.matchMedia && w.matchMedia(q).matches); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  /* ---------- Header: stuck state + one-line nav guard ---------- */
  var hdr = d.querySelector('[data-header]');
  if (hdr) {
    var nav = hdr.querySelector('.hdr__nav'), stuck = null;
    var onScroll = function () { var s = w.scrollY > 8; if (s !== stuck) { stuck = s; hdr.classList.toggle('is-stuck', s); } };
    w.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    var fit = function () {
      if (!nav) return;
      hdr.classList.remove('hdr--compact');
      if (getComputedStyle(nav).display === 'none') return;
      if (nav.scrollWidth > nav.clientWidth + 1) hdr.classList.add('hdr--compact');
    };
    var ft = 0, lastW = 0;
    var queueFit = function () { var iw = w.innerWidth; if (iw === lastW) return; lastW = iw; cancelAnimationFrame(ft); ft = requestAnimationFrame(fit); };
    w.addEventListener('resize', queueFit, { passive: true });
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { lastW = 0; queueFit(); });
    w.addEventListener('load', function () { lastW = 0; queueFit(); });
    queueFit();
  }

  /* ---------- Popup: lock page scroll while open ---------- */
  var pop = d.querySelector('[data-popup]');
  if (pop && 'MutationObserver' in w) {
    new MutationObserver(function () { root.classList.toggle('pop-lock', pop.classList.contains('is-open')); }).observe(pop, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Depth / parallax ---------- */
  if (mq('(prefers-reduced-motion: reduce)') || !('IntersectionObserver' in w)) return;
  var small = w.innerWidth < 768;
  if (small) root.style.setProperty('--k', '.5');

  var vh = w.innerHeight, ticking = false, active = [];
  var items = $$('.roll, .roll__arrow, .demo__screen, .film__stage, .vs__new, .vs__old, .dp__col, .mosaic .shot, .story__new, .story__old, .promo__screen, .promo__photo');
  var hero = d.querySelector('.hero');

  function update() {
    ticking = false;
    for (var i = 0; i < active.length; i++) {
      var el = active[i], b = el.getBoundingClientRect();
      var r = (b.top - vh * 0.3) / (vh * 0.7); r = r < 0 ? 0 : r > 1 ? 1 : r;          /* 1 entering -> 0 settled */
      var c = (vh - b.top) / (vh + b.height) - 0.5; c = c < -0.5 ? -0.5 : c > 0.5 ? 0.5 : c; /* -.5 .. .5 drift */
      r = Math.round(r * 1000) / 1000; c = Math.round(c * 1000) / 1000;
      if (el.__r !== r) { el.__r = r; el.style.setProperty('--r', r); }
      if (el.__c !== c) { el.__c = c; el.style.setProperty('--c', c); }
    }
    if (hero && hero.__on) {
      var hb = hero.getBoundingClientRect();
      var hp = Math.round(Math.min(1, Math.max(0, -hb.top / hb.height)) * 1000) / 1000;
      if (hero.__hp !== hp) { hero.__hp = hp; hero.style.setProperty('--hp', hp); }
    }
  }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.target === hero) { hero.__on = e.isIntersecting; return; }
      var k = active.indexOf(e.target);
      if (e.isIntersecting && k < 0) active.push(e.target);
      else if (!e.isIntersecting && k > -1) active.splice(k, 1);
    });
    req();
  }, { rootMargin: '15% 0px 15% 0px' });
  items.forEach(function (el) { io.observe(el); });
  if (hero) io.observe(hero);
  w.addEventListener('scroll', req, { passive: true });
  w.addEventListener('resize', function () { vh = w.innerHeight; req(); }, { passive: true });
  req();

  /* ---------- Hero pointer tilt (desktop, fine pointer only) ---------- */
  if (hero && !small && mq('(hover: hover) and (pointer: fine)')) {
    var tx = 0, ty = 0, cx = 0, cy = 0, raf = 0;
    var loop = function () {
      cx += (tx - cx) * 0.07; cy += (ty - cy) * 0.07;
      hero.style.setProperty('--ry', (cx * 6).toFixed(3) + 'deg');   /* max ±3deg */
      hero.style.setProperty('--rx', (-cy * 4).toFixed(3) + 'deg');  /* max ±2deg */
      hero.style.setProperty('--mx', cx.toFixed(3));
      raf = (Math.abs(tx - cx) > 0.0015 || Math.abs(ty - cy) > 0.0015) ? requestAnimationFrame(loop) : 0;
    };
    hero.addEventListener('pointermove', function (e) {
      var b = hero.getBoundingClientRect();
      tx = Math.max(-0.5, Math.min(0.5, (e.clientX - b.left) / b.width - 0.5));
      ty = Math.max(-0.5, Math.min(0.5, (e.clientY - b.top) / b.height - 0.5));
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
    hero.addEventListener('pointerleave', function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(loop); });
  }
})();
